<template>
  <Card class="role-item">
    <p slot="title">
      <Icon type="ios-role"></Icon>
      {{ model.role }}
    </p>
    <a href="#" @click="edit" slot="extra">
      <Icon type="ios-create" color="#ff9900" size="20" />
    </a>
    <router-link :to="'/role?item=' + model.role" slot="extra">
      <Icon type="ios-eye" color="#2db7f5" size="20" />
    </router-link>
    {{ model.note }}
  </Card>
</template>

<script>
export default {
  name: 'role-item',
  data: function () {
    return {}
  },
  props: ['model'],
  methods: {
    edit: function () {
      this.$emit('edit', this.model.role)
    }
  }
}
</script>

<style>
.role-item > a {
  background-color: #d7de51;
}
.role-item-actions {
  margin-top: 5px;
  text-align: center;
}
</style>
